<template>
  <div>
    <v-container class="px-8 py-6">
      <PageHeader class="mb-6" :loading="loadingVipSale">
        <template v-slot:title>SRS Codes</template>
        <template v-if="!loadingVipSale && vipSale" v-slot:subtitle
          >Product: <b>{{ productNumber }}</b>
        </template>
        <template v-slot:actions>
          <v-btn
            color="secondary"
            :disabled="loadingVipSale"
            @click="srsCodeChangeDialogOpened = true"
          >
            <v-icon left>mdi-swap-horizontal</v-icon>
            Change SRS Code
          </v-btn>
        </template>
      </PageHeader>

      <v-card v-if="!loadingVipSale && vipSale">
        <v-tabs vertical>
          <v-tab class="_overviewTab" ref="overviewTab">
            <v-layout align-center>
              <v-icon left> mdi-information-outline </v-icon>
              Overview
            </v-layout>
          </v-tab>
          <v-tab class="_srsCodeChangesTab" ref="srsCodeChangesTab">
            <v-layout align-center>
              <v-icon left> mdi-list-status </v-icon>
              SRS Code Changes
            </v-layout>
          </v-tab>
          <v-tab-item class="_overviewTabContent">
            <v-card v-if="!loadingVipSale && vipSale">
              <v-card-text>
                <v-text-field
                  v-if="vipSale.createdBy"
                  label="Created By"
                  readonly
                  v-model="vipSale.createdBy"
                />
                <v-text-field
                  label="SRS Code"
                  readonly
                  v-model="vipSale.srsCode"
                />
                <v-expansion-panels hover multiple v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header>Product</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-text-field
                        label="Item Number"
                        readonly
                        v-model="vipSale.product.itemNumber"
                      />
                      <v-text-field
                        label="Description"
                        readonly
                        v-model="vipSale.product.description"
                      />
                      <v-text-field
                        label="Status"
                        readonly
                        v-model="vipSale.product.status"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      >Supplier</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <v-text-field
                        label="Internal ID"
                        readonly
                        v-model="vipSale.supplier.internalId"
                      />
                      <v-text-field
                        label="Name"
                        readonly
                        v-model="vipSale.supplier.name"
                      />
                      <v-text-field
                        label="Reference"
                        readonly
                        v-model="vipSale.supplier.reference"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      >Location</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <v-text-field
                        label="Location ID"
                        readonly
                        v-model="vipSale.location.locationId"
                      />
                      <v-text-field
                        label="Description"
                        readonly
                        v-model="vipSale.location.description"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item class="_srsCodeChangesTab">
            <Table
              :items="srsCodeChanges"
              :actions="srsCodeChangesTableActions"
              :hideColumns="['srsCodeChangeLogs']"
              @refresh="onSrsCodeLogsRefreshClicked"
            />
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-container>

    <SrsCodeChangeDialog
      v-if="!loadingVipSale && vipSale"
      :opened="srsCodeChangeDialogOpened"
      :srsCode="vipSale"
      @cancel="srsCodeChangeDialogOpened = false"
      @saved="onSrsCodeChangeQueued"
    />

    <v-dialog max-width="370" v-model="notificaionDialogOpened">
      <v-card>
        <v-card-text class="pa-0">
          <v-alert class="ma-0" text type="success">
            The SRS code change has been queued!
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <SrsCodeChangeLogsDrawer
      :codeSnapshot="srsCodeChangeLogsDrawerCodeSnapshot"
      :codeChange="srsCodeChangeLogsDrawerCodeChange"
      :logs="srsCodeChangeLogsDrawerItems"
      :opened="srsCodeChangeLogsDrawerOpened"
      @closed="srsCodeChangeLogsDrawerOpened = false"
    />
  </div>
</template>

<script>
import api from "../../../../api";
import dates from "../../../../utils/dates";
import { TableAction } from "../../../../components/tables/Table/TableAction";
export default {
  data() {
    return {
      loadingVipSale: false,
      vipSale: undefined,
      panel: [0, 1, 2],
      srsCodeChangesTableActions: [
        new TableAction("View Logs", {
          icon: "list-status",
          click: (item) => {
            this.srsCodeChangeLogsDrawerCodeSnapshot = item.codeSnapshot;
            this.srsCodeChangeLogsDrawerCodeChange = item.codeChange;
            this.srsCodeChangeLogsDrawerOpened = true;
            this.srsCodeChangeLogsDrawerItems = item.srsCodeChangeLogs;
          },
        }),
        new TableAction("Retry", {
          icon: "refresh",
          click: async (item) => {
            await api.vipSales.enqueueSrsCodeChangeAsync(
              this.productNumber,
              item.codeSnapshot,
              item.codeChange
            );
            this.onSrsCodeChangeQueued();
          },
          hidden: (item) => item.status != "Failed",
        }),
      ],
      srsCodeChangeDialogOpened: false,
      notificaionDialogOpened: false,
      srsCodeChangeLogsDrawerCodeSnapshot: "",
      srsCodeChangeLogsDrawerCodeChange: "",
      srsCodeChangeLogsDrawerOpened: false,
      srsCodeChangeLogsDrawerItems: [],
    };
  }, //data

  mounted() {
    this.loadVipSaleAsync();
  }, // mounted

  computed: {
    tabQueryParam() {
      return `${this.$route.query.tab}Tab`;
    },
    productNumber() {
      if (!this.vipSale) return "undefined vipSale";
      if (!this.vipSale.product) return "undefined vipSale.product";
      return this.vipSale.product.itemNumber;
    },
    srsCodeChanges() {
      if (!this.vipSale) return [];
      if (!this.vipSale.srsCodeChanges) return [];
      return this.vipSale.srsCodeChanges.map((x) => ({
        dateChanged:
          x.dateCreated != null
            ? dates.MMDDYYYYHHmmss(x.dateCreated)
            : "Unknown",
        changedBy: x.createdBy,
        codeSnapshot: x.srsCodeOld,
        codeChange: x.srsCodeNew,
        status: x.status,
        logs: x.srsCodeChangeLogs != null ? x.srsCodeChangeLogs.length : 0,
        srsCodeChangeLogs: x.srsCodeChangeLogs,
      }));
    },
  }, // computed

  methods: {
    onSrsCodeChangeQueued() {
      this.srsCodeChangeDialogOpened = false;
      this.notificaionDialogOpened = true;
      this.loadVipSaleAsync();
    },
    onSrsCodeLogsRefreshClicked() {
      this.loadVipSaleAsync();
    },
    changeTab(tabName) {
      const tabComponent = this.$refs[tabName];
      if (tabComponent != null) tabComponent.$el.click();
    },
    async loadVipSaleAsync() {
      this.loadingVipSale = true;
      const product = this.$route.params.product;
      this.vipSale = await api.vipSales.getByProductAsync(product);
      this.loadingVipSale = false;
      this.$nextTick().then(() => this.changeTab(this.tabQueryParam));
    },
  }, // methods
};
</script>
